<template lang="pug">

.rates-table__row(@click="toggleActive" :class="{'is-active' : isActive}")

    .rates-table__caption
      .rates-table__title {{ title }}

      .rates-table__switcher(v-if="switcher")
        .switcher(@click.prevent="changeState" :class="{'is-active' : switchState}")
          .switcher__item

      .rates-table__value(v-if="value")
        .rates-table__price {{ value }} #[span(class="text-green") {{ extraValue }}]
        .rates-table__param {{ symbol }}
      .rates-table__time(v-if="time")  {{ time }}

    transition(name="slide-toggle"
               @enter="slideToggleStart"
               @after-enter="slideToggleEnd"
               @before-leave="slideToggleStart"
               @after-leave="slideToggleEnd")
      .rates-table__content(v-if="isActive")
        p Действует с момента открытия автомобиля через прилоджение и до момента закрытия автомобиля или завершения аренды

</template>

<script>
export default {
  props: ['title', 'value', 'extraValue', 'time', 'symbol', 'switcher'],
  components: {},
  data () {
    return {
      isActive: false,
      switchState: false
    }
  },
  methods: {
    slideToggleStart (el) {
      el.style.height = el.scrollHeight + 'px'
    },
    slideToggleEnd (el) {
      el.style.height = ''
    },
    toggleActive () {
      this.isActive = !this.isActive
      this.$root.$emit('rowToggled', this.isActive)
    },
    changeState () {
      this.isActive = !this.isActive
      this.switchState = !this.switchState
      this.$emit('changeState', this.switchState)
    }
  },
  computed: {
  }

}
</script>

<style lang="sass">

</style>



// WEBPACK FOOTER //
// src/components/rates-table-row.vue